import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import WebApp from "@twa-dev/sdk";

import { NavBar } from "./components/NavBar";
import { PlansScreen } from "./screens/PlansScreen";
import { CheckoutScreen } from "./screens/CheckoutScreen";
import { MySubscriptionScreen } from "./screens/MySubscriptionScreen";
import { ChangePlanScreen } from "./screens/ChangePlanScreen";
import { MoreScreen } from "./screens/MoreScreen";
import "./i18n";

export function App() {
  useEffect(() => {
    WebApp.ready();
    WebApp.expand();
  }, []);

  return (
    <BrowserRouter>
      {/* Таббар сверху, не снизу — на мобильных Telegram-клиентах нижняя зона экрана конфликтует
          со свайпом закрытия Mini App, пользователю было неудобно попадать по вкладкам
          (найдено 2026-08-20). См. .nav-bar в src/styles/theme.css. */}
      <NavBar />
      <main className="screen">
        <Routes>
          <Route path="/" element={<PlansScreen />} />
          <Route path="/checkout/:planId" element={<CheckoutScreen />} />
          {/* Устройства (экран 4 ТЗ) объединены с "Моя подписка" — см. MySubscriptionScreen.tsx */}
          <Route path="/subscription" element={<MySubscriptionScreen />} />
          <Route path="/change-plan" element={<ChangePlanScreen />} />
          {/* Платежи/Отмена/Промокод (экраны 6-8 ТЗ) объединены на одной странице — см.
              MoreScreen.tsx, причина — 7 вкладок не помещались в нижний таббар на узком экране. */}
          <Route path="/more" element={<MoreScreen />} />
        </Routes>
      </main>
    </BrowserRouter>
  );
}
